import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { isURL } from 'validator';
import { Label, Input, FormGroup, InputGroup, InputGroupAddon, Button, Col } from 'reactstrap';
import { string, func } from 'prop-types';

class FlowPostbackUrl extends PureComponent {
  static propTypes = {
    url: string.isRequired,
    onUrlChange: func.isRequired,
    onCheckPostback: func.isRequired,
  };

  isValidUrl = url => isURL(url);

  render() {
    const { url, onUrlChange, onCheckPostback } = this.props;

    return (
      <FormGroup row>
        <Label lg={2} for="postback-url">URL</Label>
        <Col lg={10}>
          <InputGroup>
            <Input
              type="url"
              name="url"
              id="postback-url"
              onChange={({ target }) => {
                onUrlChange({ [target.name]: target.value });
              }}
              value={url}
              placeholder="http://example.com/"
            />
          </InputGroup>
        </Col>
      </FormGroup>
    );
  }
}

export default FlowPostbackUrl;
